<template>
  <v-container fluid class="pa-0" style="margin-top: 2vh">
    <project-flow-navigation-toolbar
      :title="packageName"
    ></project-flow-navigation-toolbar>
    <v-data-table
      v-if="packageName"
      :headers="headers"
      :items="this.$store.state.ItemStore.items"
      :items-per-page="10"
      class="elevation-1"
      :search="search"
    >
      <template v-slot:top>
        <v-row class="upper-elements">
          <v-col class="d-flex align-center">
            <v-dialog persistent v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on }">
                <v-btn class="ml-4" small v-on="on">Create Item</v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline"> {{ formTitle }} </span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="6" md="8">
                        <v-text-field
                          v-model="editedItem.name"
                          label=" Item name"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="close"
                    >Cancel</v-btn
                  >
                  <v-btn color="blue darken-1" text @click="save">Save</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-col>
          <v-col cols="2" sm="2" md="2">
            <v-text-field
              dense
              v-model="search"
              append-icon="mdi-magnify"
              outlined=""
              label="Search"
              hide-details
              class="mr-4"
            ></v-text-field>
          </v-col>
        </v-row>
      </template>
      <template v-slot:[`item.action`]="{ item }">
        <v-icon size="18" class="mr-3" @click="editItem(item, $event)"
          >edit</v-icon
        >
        <v-icon size="24" @click="deleteItem(item, $event)">close</v-icon>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import ProjectFlowNavigationToolbar from '../../components/AppBar/ProjectFlowNavigationToolbar'

export default {
  name: 'items',
  components: {
    ProjectFlowNavigationToolbar
  },
  items: {
    type: Array,
    required: true,
    default: function() {
      return {}
    }
  },
  data: function() {
    return {
      editedIndex: -1,
      editedItem: {
        id: 0,
        name: '',
        packagesId: 0
      },
      defaultItem: {
        id: 0,
        name: '',
        packagesId: 0
      },
      dialog: false,
      search: ''
    }
  },
  computed: {
    headers() {
      return [
        {
          text: 'ITEMS',
          align: 'left',
          sortable: true,
          value: 'name'
        },
        { text: 'Actions', value: 'action', sortable: false, align: 'right' }
      ]
    },
    packageName() {
      return this.$store.state.ProjectPackagesStore.selectedPackage
        ? this.$store.state.ProjectPackagesStore.selectedPackage.name
        : ''
    },
    formTitle() {
      return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
    }
  },
  watch: {
    dialog(val) {
      val || this.close()
    }
  },

  created: async function() {
    let packageId = parseInt(this.$route.params.packagesId)
    await this.$store.dispatch(
      'ProjectPackagesStore/setSelectedPackage',
      packageId
    )
    this.$store.dispatch('ItemStore/fetchItems')
  },

  methods: {
    editItem(item, e) {
      e.stopPropagation()
      e.preventDefault()
      this.editedIndex = item.id
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },
    deleteItem(item, e) {
      e.stopPropagation()
      this.$store.dispatch('DialogStore/open', {
        title: 'Delete ' + this.context,
        header: false,
        subtitle: 'Are you sure?',
        okText: 'Ok',
        ok: () => {
          this.deleteItemAction(item)
        },
        cancelText: 'Cancel'
      })
    },
    async deleteItemAction(item) {
      await this.$store.dispatch('ItemStore/deleteItem', item.id)
      this.$store.dispatch('ItemStore/fetchItems')
    },

    close() {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    save: async function() {
      if (this.editedIndex > -1) {
        //UPDATE
        this.$store.dispatch('ItemStore/updateItem', this.editedItem)
      } else {
        //CREATE
        this.editedItem.packagesId = this.$store.state.ProjectPackagesStore.selectedPackage.id

        await this.$store.dispatch('ItemStore/addItem', this.editedItem)
      }
      this.close()
    }
  }
}
</script>

<style lang="scss" scoped>
.upper-elements {
  margin-bottom: 0px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  margin-top: 1px;
}
.v-data-footer {
  margin-bottom: 16px !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12) !important;
}
</style>
